import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Download, Filter, Grid3X3, Maximize, Minimize } from "lucide-react";
import ToggleSwitcher from "../ToggleView/ToggleSwitcher";
import TopTitleWithButton from "../toptitlecomponent/TopTitleWithButton";
import NewSearch from "./NewSearch";
import CustomTooltip from "@/components/ui/CustomTooltip";
import { useFullScreen } from "@component/fullscreen/FullScreenWrapper";


const SearchWithFilter = ({ children }) => {
  return <div className="w-full">{children}</div>;
};

// title bar
SearchWithFilter.Title = ({ icon, title, subtitle, isNeedIcon,...props }) => (
  <div className="flex flex-col w-full">
    <TopTitleWithButton icon={icon} title={title} subtitle={subtitle} isNeedIcon={isNeedIcon} {...props} />
  </div>
);

// search bar with filter
SearchWithFilter.SearchBar = ({
  value,
  onChange,
  onSearch,
  onToggleFilter,
  filterCount = 0,
  isVisibleBtn = true,
  isfilterVisible = true,
  width = "250px",
  isSearchVisible = true,
  filtername = "Advance Filters",
  isVisibleFilterIcon = true,
  height,
}) => (
  <div
    className={cn(
      "font-sans flex flex-col gap-2 w-full",
      "sm:flex-row sm:items-center sm:gap-3"
    )}
  >
    {isSearchVisible && (
      <div className="w-full sm:w-auto">
        <NewSearch
          value={value}
          onChange={onChange}
          onSearch={onSearch}
          isVisibleBtn={isVisibleBtn}
          width={width}
          height={height}
        />
      </div>
    )}

    {isfilterVisible && (
      <div className="w-full sm:w-auto">
        <Button
          onClick={onToggleFilter}
          className="w-full sm:w-auto bg-primary-foreground border border-card-border text-foreground hover:bg-primary-foreground/20"
        >
          {isVisibleFilterIcon && <Filter className="w-4 h-4 mr-2" />}
          {filtername}
          {filterCount > 0 && (
            <span
              className={cn(
                "ml-2 px-1.5 rounded-full text-xs font-medium min-w-[20px] h-5 flex items-center justify-center",
                "bg-primary text-white"
              )}
            >
              {filterCount}
            </span>
          )}
        </Button>
      </div>
    )}
  </div>
);
// 🔹 Export Icon
SearchWithFilter.Exporticon = ({ onClick, isLoading }) => {
  return (
    <CustomTooltip content="Export" side="top" delayDuration={0}>
      <div className="h-10">
        <Button
          variant="outline"
          onClick={onClick}
          disabled={isLoading}
          className="h-10 px-3 flex items-center justify-center border border-card-border"
        >
          <Download className="h-5 w-5" />
        </Button>
      </div>
    </CustomTooltip>
  );
};

const FullScreenToggle = ({ toggleView }) => {
  const { toggleFullscreen, isFullscreen } = useFullScreen();

  if (toggleView !== "table") return null;

  return (
    <CustomTooltip
      content={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
      side="top"
      delayDuration={0}
    >
      <div className="h-10">
        <Button
          variant="outline"
          onClick={toggleFullscreen}
          className="h-10 px-3 flex items-center justify-center border border-card-border"
        >
          {isFullscreen ? (
            <Minimize className="h-5 w-5" />
          ) : (
            <Maximize className="h-5 w-5" />
          )}
        </Button>
      </div>
    </CustomTooltip>
  );
};

SearchWithFilter.FullScreenToggle = FullScreenToggle

SearchWithFilter.ViewToggle = ({ value, onChange }) => (
  <div className="flex flex-row items-center ml-auto gap-2 mt-2 sm:mt-0">
    <ToggleSwitcher value={value} onChange={onChange} />
  </div>
);

SearchWithFilter.OldViewToggle = ({ active, onChange }) => (
  <div className="flex items-center space-x-1 bg-muted p-1 rounded-lg">
    <Button
      variant={active ? "default" : "ghost"}
      size="sm"
      onClick={onChange}
      className="h-8 px-3"
    >
      <Grid3X3 className="h-4 w-4" />
    </Button>
  </div>
);


export default SearchWithFilter;
